module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 1.42698","quantity":0.01427},{"color":"#9dc4b5","label":" 1.42698- 1.42698","quantity":0.01427},{"color":"#e6efc3","label":" 1.42698- 1.51454","quantity":0.01515},{"color":"#ffe89e","label":" 1.51454- 1.96749","quantity":0.01967},{"color":"#f5af7f","label":" 1.96749- 2.9496","quantity":0.0295},{"color":"#ed6d32","label":" 2.9496- 16.11582","quantity":0.16116}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_80_return_20.json
// module id = abbn
// module chunks = 171